export default __webpack_public_path__ + "5f498bc5e4f201a6d18c88b68756d9b1.png";